import { Injectable } from '@angular/core';

declare let delta: any;

@Injectable({
  providedIn: 'root'
})
export class QueryStringHelper {
  constructor() {}

  getParameterByName(name) {
    const urlParam = window.location.search;
    const values = [];
    if (urlParam !== '' && urlParam !== 'undefined') {
      if (name === 'departureDate' || name === 'returnDate') {
        const url = window.location.href;
        name = name.replace(/[\[\]]/g, '\\$&');
        name = name.replace(/\\/g, '');
        const regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
          results = regex.exec(url);
        if (!results) {
          return null;
        }
        if (!results[2]) {
          return '';
        }
        return decodeURIComponent(results[2].replace(/\+/g, ' '));
      } else {
        name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
        name = name.replace(/\\/g, '');
        const pattern = name + '=([^&#]+)';
        const o_reg = new RegExp(pattern, 'ig');
        while (true) {
          const matches = o_reg.exec(urlParam);
          if (matches && matches[1]) {
            values.push(matches[1]);
          } else {
            break;
          }
        }

        if (!values.length) {
          return null;
        } else {
          return values.length === 1 ? values[0] : values;
        }
      }
    }
  }

  parse_query_string() {
    const urlParam = window.location.search;
    if (urlParam !== '' && urlParam !== 'undefined') {
      const vars = urlParam.split('&');
      const query_string = {};
      for (let i = 0; i < vars.length; i++) {
        const pair = vars[i].split('=');
        const key = decodeURIComponent(pair[0].replace(/\+/g, ' '));
        const value = decodeURIComponent(pair[1]);
        if (typeof query_string[key] === 'undefined') {
          query_string[key] = decodeURIComponent(value);
        } else if (typeof query_string[key] === 'string') {
          const arr = [
            query_string[key],
            decodeURIComponent(value).replace(/\+/g, ' ')
          ];
          query_string[key] = arr;
        } else {
          query_string[key].push(decodeURIComponent(value).replace(/\+/g, ' '));
        }
      }
      return query_string;
    }
  }
}
